import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

function Navbar() {
  const [click, setClick] = useState(false);

  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 960) {
        setClick(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <nav className='navbar'>
      <div className='navbar-container'>
        <Link to='/' className='navbar-logo' onClick={closeMobileMenu}>
          <span className='brand-mark' aria-hidden='true'>M</span>
          <span>Mukwei <small>Gin</small></span>
        </Link>

        <button type='button' className='menu-icon' onClick={handleClick} aria-label='Toggle menu'>
          <i className={click ? 'fas fa-times' : 'fas fa-bars'} />
        </button>

        <ul className={click ? 'nav-menu active' : 'nav-menu'}>
          <li className='nav-item'>
            <Link to='/' className='nav-links' onClick={closeMobileMenu}>
              Our Gin
            </Link>
          </li>
          <li className='nav-item'>
            <Link to='/checkout' className='nav-links' onClick={closeMobileMenu}>
              Reserve
            </Link>
          </li>
          <li className='nav-item'>
            <Link to='/track' className='nav-links' onClick={closeMobileMenu}>
              Track Order
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;
